import dashboard5APIsService from "../dashboard5APIs";
import { createDataHook } from "../../helpers/util";
import { getStars, GOOGLE_CHARTS_TYPES } from "../../consts/graphs";

const useFetchDashboard5Data = createDataHook(
  dashboard5APIsService,
  (filters, params, controller, apiService = dashboard5APIsService) => ({
    fetchSummaryCardsData: () =>
      apiService.fetchSummaryCardsData(filters, controller.signal),
    fetchRatingBreakdownData: () =>
      apiService.fetchRatingBreakdownData(
        { ...params, chartType: GOOGLE_CHARTS_TYPES.PIECHART },
        controller.signal
      ),
    fetchIndividualCourseRatingWithCommentsData: () =>
      apiService.fetchIndividualCourseRatingWithCommentsData(
        { ...params, sortBy: "course", sortOrder: "asc" },
        controller.signal
      ),
    fetchOverallCourseRatingData: () =>
      apiService.fetchOverallCourseRatingData(
        { ...params, sortBy: "avgRating", sortOrder: "desc" },
        controller.signal
      ),
    fetchHighestRatedCoursesData: () =>
      apiService.fetchHighestRatedCoursesData({
        ...params,
        sortBy: "avgRating",
        sortOrder: "desc",
        highestRatings: true,
        ratingNumber: 4,
      }, controller.signal),
    fetchLowestRatedCoursesData: () =>
      apiService.fetchLowestRatedCoursesData({
        ...params,
        sortBy: "avgRating",
        sortOrder: "asc",
        highestRatings: false,
        ratingNumber: 3,
      }, controller.signal),
    fetchAverageCourseRatingByMonthData: () =>
      apiService.fetchAverageCourseRatingByMonthData(
        { ...params, chartType: GOOGLE_CHARTS_TYPES.LINECHART },
        controller.signal
      ),
  }),
  { preflight: "shared" }
);

export default useFetchDashboard5Data;
